import { Auth } from "aws-amplify";
import { UserType } from "../../../graphql/types";
import enumStrings, { RedirectUri } from "../../enumStrings";
import {
  clearPendingNewPasswordChallenge,
  setPendingNewPasswordChallenge,
} from "./pendingNewPasswordChallenge";
import { getSingleCognitoUserTypeFromGroups } from "../../common/utilities/adminConsoleUserType";

export const signInHandler = async (
  email: string,
  password: string,
  onNewPasswordRequired?: () => void
): Promise<void> => {
  try {
    clearPendingNewPasswordChallenge();
    sessionStorage.removeItem(
      enumStrings.sessionStorageKey.loggedInWithTemporaryPassword
    );
    const user = await Auth.signIn(email, password);

    if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      if (!onNewPasswordRequired) {
        await Auth.signOut();
        const challengeError = new Error(
          "A new password must be set interactively."
        ) as Error & { code?: string };
        challengeError.code = "NewPasswordChallengeRequiresInteractiveLogin";
        throw challengeError;
      }

      setPendingNewPasswordChallenge({
        email,
        user,
      });
      onNewPasswordRequired();
      return;
    }

    if (
      user.signInUserSession &&
      user.signInUserSession.idToken &&
      user.signInUserSession.idToken.payload &&
      user.signInUserSession.idToken.payload["custom:isDisabled"] === "true"
    ) {
      await Auth.signOut();

      const disabledError = new Error("This account is disabled.") as Error & {
        code?: string;
      };
      disabledError.code = "UserDisabled";
      throw disabledError;
    }

    const signedInUserType = getSingleCognitoUserTypeFromGroups(
      user.signInUserSession?.accessToken?.payload?.["cognito:groups"]
    );
    if (!signedInUserType || signedInUserType === UserType.CapUser) {
      await Auth.signOut();
      const accessError = new Error(
        "This account cannot access this dashboard."
      ) as Error & { code?: string };
      accessError.code =
        signedInUserType === UserType.CapUser
          ? "CapUserTryingToSignIn"
          : "UserDisabled";
      throw accessError;
    }

    window.location.href = RedirectUri.home;
  } catch (error) {
    throw error;
  }
};
